// extracted by mini-css-extract-plugin
export default {"container":"SelectMultiplePersonsButton__container___vgqTG","addPersonButton":"SelectMultiplePersonsButton__addPersonButton___p9VPt"};